import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { EnvioDocumentoTracesService } from './enviodocumentotraces.service';
import { HttpParams } from '@angular/common/http';
import { EnvioDocumentoTracesItemResultsViewModel, EnvioDocumentoTracesViewModel, EnvioDocumentoTracesItemViewModel } from './enviodocumentotraces.types';
import { ConfirmationService } from 'primeng/api';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { Tc } from '../../../core/_infrastructure/types/common';
import { DatePipe } from '@angular/common';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { Table } from 'primeng/table';

@Component({
    selector: 'app-enviodocumentotraces-list',
    templateUrl: './enviodocumentotraces-list.component.html',
})
export class EnvioDocumentoTracesListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    resultEnvioDocumentoTraces: EnvioDocumentoTracesItemResultsViewModel;
    listEstadoSolicitud: Tc[];
    listTipoDocumento: Tc[];
    firstDayMonth: Date;
    lastDayMonth: Date;
    cols: any[];
    visibilitySpinner = false;
    public isCollapsed = false;

    constructor(
        public datepipe: DatePipe,
        private router: Router,
        private fb: FormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private envioDocumentoTracesService: EnvioDocumentoTracesService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultEnvioDocumentoTraces = new EnvioDocumentoTracesItemResultsViewModel();
    }

    ngOnInit() {
        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },

            { field: 'IdDocumentoSolicitud', header: 'Id DocumentoSolicitud' },
            { field: 'IdSolicitud', header: 'Id Solicitud' },
            { field: 'CodigoSolicitud', header: 'Código Solicitud' },
            { field: 'EstadoSolicitud', header: 'Estado Solicitud' },
            { field: 'Chedpp', header: 'CHED PP' },
            { field: 'DescripcionDocumento', header: 'Documento' },
            { field: 'ReferenciaTraces', header: 'Referencia TRACES' },
            { field: 'FechaInicio', header: 'FechaInicioDatetime', display: 'none' }, //tipo Datetime
            { field: 'FechaFin', header: 'FechaFinDatetime', display: 'none' }, //tipo Datetime
            { field: 'FechaInicioCompleta', header: 'Fecha Inicio' }, // | date:'dd/MM/yyyy' tipo string
            { field: 'FechaFinCompleta', header: 'Fecha Envío' }, // | date:'dd/MM/yyyy' tipo string
            { field: 'Duracionms', header: 'Duración (ms)' },
        ];

        this.globalService.getEstadoSolicitud().subscribe(res => {
            this.listEstadoSolicitud = res;
        });
        this.globalService.getTipoDocumento().subscribe(res => {
            this.listTipoDocumento = res;
        });

        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        //this.firstDayMonth = this.datepipe.transform(dateTemp, 'yyyy-MM-dd');
        let temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - 0.001 * 60 * 60 * 24);
        //this.lastDayMonth = this.datepipe.transform(dateTemp2, 'yyyy-MM-dd');

        this.form = this.fb.group({
            IdSolicitud: null,
            CodigoSolicitud: '',
            IdTipoDocumento: null,
            IdEstadoSolicitud: null,
            ChedPp: '',
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
        });

        this.loadBack();
    }

    loadBack() {
        if (
            this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.FechaDesde == null ||
            this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.FechaHasta == null ||
            this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.IdEstadoSolicitud > 0 ||
            this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.IdSolicitud > 0 ||
            this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.CodigoSolicitud != '' ||
            this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.ChedPp != '' ||
            this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.FechaDesde!.toString() != this.firstDayMonth.toString() ||
            this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.FechaHasta!.toString() != this.lastDayMonth.toString()
        ) {
            this.form.patchValue({
                IdSolicitud: this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.IdSolicitud,
                IdEstadoSolicitud: this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.IdEstadoSolicitud,
                IdTipoDocuemnt: this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.IdTipoDocumento,
                CodigoSolicitud: this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.CodigoSolicitud,
                ChedPp: this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.ChedPp,
                FechaDesde: this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.FechaDesde,
                FechaHasta: this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.FechaHasta,
            });

            this.onSearchButton();
        }
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.IdSolicitud = this.form.value.IdSolicitud;
        this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.IdEstadoSolicitud = this.form.value.IdEstadoSolicitud;
        this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.IdTipoDocumento = this.form.value.IdTipoDocumento;
        this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.CodigoSolicitud = this.form.value.CodigoSolicitud;

        this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.ChedPp = this.form.value.ChedPp;
        this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.FechaDesde = this.form.value.FechaDesde;
        this.envioDocumentoTracesService.currentFilterEnvioDocumentosTraces.FechaHasta = this.form.value.FechaHasta;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    //getFechaHasta(): Date {
    //    (this.form.value.FechaHasta as Date).setHours(23);
    //    (this.form.value.FechaHasta as Date).setMinutes(59);
    //    (this.form.value.FechaHasta as Date).setSeconds(59);

    //    return this.form.value.FechaHasta as Date;
    //}

    getFechaDesde(): Date {
        return this.form.value.FechaDesde as Date;
    }

    getFechaHasta(): Date {
        return this.form.value.FechaHasta as Date;
    }

    Search(pageNumber: number, asc = -1, orderBy = 'FechaFin') {
        let params = new HttpParams();

        if (orderBy == 'FechaFinCompleta') {
            orderBy = 'FechaFin'; //no es necesario que esté en el filtro del cliente, pero sí­ en el del servidor
        }
        if (orderBy == 'FechaInicioCompleta') {
            orderBy = 'FechaInicio'; //no es necesario que esté en el filtro del cliente, pero sí­ en el del servidor
        }

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('IdSolicitud', this.form.value.IdSolicitud);
        params = params.append('IdEstadoSolicitud', this.form.value.IdEstadoSolicitud);
        params = params.append('IdTipoDocumento', this.form.value.IdTipoDocumento);
        params = params.append('CodigoSolicitud', this.form.value.CodigoSolicitud);

        params = params.append('ChedPp', this.form.value.ChedPp);
        params = params.append('FechaDesde', this.form.value.FechaDesde != null ? this.getFechaDesde().toLocaleString() : '');
        params = params.append('FechaHasta', this.form.value.FechaHasta != null ? this.getFechaHasta().toLocaleString() : '');

        this.loading = true;
        this.envioDocumentoTracesService.getEnvioDocumentoTracesPagedByFilter(params).subscribe(result => {
            this.resultEnvioDocumentoTraces = result;

            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton() {
        this.form.setValue({
            IdSolicitud: null,
            CodigoSolicitud: '',
            IdEstadoSolicitud: null,
            IdTipoDocumento: null,
            ChedPp: '',
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
        });

        this.searchingButton = false;
        this.isCollapsed = false;
    }

    onView(item: EnvioDocumentoTracesItemViewModel) {
        this.router.navigate(['/mantenimiento/envios/documentostraces/edit', item.Id]);
    }

    onSend(item: EnvioDocumentoTracesItemViewModel) {
        this.confirmationService.confirm({
            message: 'Con esta opción se manda a TRACES inmediatamente. ¿Está seguro de mandar a TRACES este documento?',
            accept: () => {
                this.envioDocumentoTracesService.uploadDocumentoTraces(item.IdDocumentoSolicitud).subscribe(result => {
                    if (result.IsOK) {
                        this.notificacionService.addSuccessMessage('Documento aceptado en Traces TNT correctamente con Referencia:' + result.Reference);
                    } else {
                        this.notificacionService.addErrorMessage('Documento aceptado en Traces TNT');
                    }
                    this.onSearchButton();
                });
            },
        });
    }

    checkToSend(item: EnvioDocumentoTracesItemViewModel) {
        if (item.Chedpp) {
            return false;
        }

        return true;
    }

    CreateModel() {
        let model: EnvioDocumentoTracesViewModel = new EnvioDocumentoTracesViewModel();

        Object.assign(model, this.form.value);

        model.FechaHasta = this.form.value.FechaHasta != null ? this.getFechaHasta() : this.form.value.FechaHasta;

        return model;
    }

    onExportExcel() {
        this.visibilitySpinner = true;

        this.envioDocumentoTracesService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);

            this.visibilitySpinner = false;
        });
    }
}
